// eslint-disable-next-line no-underscore-dangle
export const _custom = {
	name: 'Untitled Custom Template',
	variant: 'design',
	json: {
		width: 100,
		height: 100,
		fonts: [],
		pages: [
			{
				id: 'page_1',
				children: [],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
			},
		],
		unit: 'px',
		dpi: 96,
	},
	status: 'draft',
	history: [],
	tags$Category: [],
	tags$General: [],
	etc: {
		directives: {},
		cfg: {
			global: {
				minPages: 1,
				maxPages: 50,
			},
			customer: {
				minPages: 1,
				maxPages: 50,
			},
			order: {
				countries: null,
				itemId: 'custom',
			},
			canBeResized: true,
		},
	},
};

export default _custom;
